<div class="container-fluid px-0" *ngIf="!lockFacility || facilityId>0; else noId">
    <div class="cp-filter-panel" *ngIf="!lockFacility" [formGroup]="filterForm">
        <div class="row">
            <div style="flex: 0 1 260px;">
                <label class="form-label">Instalación</label>
                <select class="form-select" formControlName="facility_id" (change)="filterChange()">
                    <option [value]="0">TODAS</option>
                    <option *ngFor="let item of facilityes" [value]="item?.id">{{item?.name | uppercase}}</option>
                </select>
            </div>
        </div>
    </div>
    <ul ngbNav #navTasks="ngbNav" [(activeId)]="active" class="nav-pills mb-3">
        <li [ngbNavItem]="1">
            <a ngbNavLink><i class="fa-solid fa-list-check me-1"></i> Listas de tareas</a>
            <ng-template ngbNavContent>
                <div class="card h-100">
                    <div class="card-header cp-list-header">
                        <span class="cp-list-title">Listas de tareas</span>
                        <button class="btn btn-primary btn-sm" (click)="openModal(add)"
                            [disabled]="!lockFacility && currentFacilityId<=0"
                            [title]="(!lockFacility && currentFacilityId<=0) ? 'Selecciona una instalación para crear una lista' : ''">
                            <i class="fa-solid fa-circle-plus me-1"></i> Nueva lista
                        </button>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table cp-table">
                                <thead>
                                    <tr>
                                        <th><span>FOLIO</span></th>
                                        <th><span>NOMBRE</span></th>
                                        <th class="cp-table-hide-mobile" *ngIf="!lockFacility"><span>INSTALACIÓN</span></th>
                                        <th class="cp-table-hide-mobile"><span>OBSERVACIÓN</span></th>
                                        <th><span>TAREAS</span></th>
                                        <th><span>ESTADO</span></th>
                                        <th class="cp-table-hide-mobile"><span>CREACIÓN</span></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="checklists?.length>0">
                                    <tr *ngFor="let item of checklists">
                                        <td><span class="badge bg-secondary">#{{item?.id}}</span></td>
                                        <td><span>{{item?.label}}</span></td>
                                        <td class="cp-table-hide-mobile" *ngIf="!lockFacility"><span>{{item?.facility_name}}</span></td>
                                        <td class="cp-table-hide-mobile"><span>{{item?.observation || '-'}}</span></td>
                                        <td><span class="badge bg-dark">{{item?.items_count}}</span></td>
                                        <td>
                                            <button type="button" class="btn btn-sm p-0 border-0 bg-transparent"
                                                (click)="toggleStatus(item)">
                                                <span class="badge"
                                                    [ngClass]="item?.active ? 'bg-primary' : 'bg-danger'">
                                                    {{ item?.active ? 'Activa' : 'Inactiva' }}
                                                </span>
                                            </button>
                                        </td>
                                        <td class="cp-table-hide-mobile"><span>{{item?.created_at}}</span></td>
                                        <td>
                                            <div class="btn-group" role="group">
                                                <button type="button" class="btn text-warning"
                                                    (click)="openEdit(item.id, edit)">
                                                    <i class="fa fa-pencil"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="!checklists?.length">
                                    <tr>
                                        <td colspan="8" class="fw-lighter text-muted">No se encontraron listas de
                                            tareas</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="2">
            <a ngbNavLink><i class="fa-solid fa-clipboard-check me-1"></i> Ejecuciones</a>
            <ng-template ngbNavContent>
                <div class="card h-100">
                    <div class="card-header cp-list-header">
                        <span class="cp-list-title">Ejecuciones registradas</span>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table cp-table">
                                <thead>
                                    <tr>
                                        <th><span>FOLIO</span></th>
                                        <th><span>CHECKLIST</span></th>
                                        <th class="cp-table-hide-mobile" *ngIf="!lockFacility"><span>INSTALACIÓN</span></th>
                                        <th><span>GUARDIA</span></th>
                                        <th><span>ESTADO</span></th>
                                        <th><span>RESPUESTAS</span></th>
                                        <th class="cp-table-hide-mobile"><span>INICIO</span></th>
                                        <th class="cp-table-hide-mobile"><span>FIN</span></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="executions?.length>0">
                                    <tr *ngFor="let item of executions">
                                        <td><span class="badge bg-secondary">#{{item?.id}}</span></td>
                                        <td>
                                            <span>{{item?.task_checklist_label}}</span>
                                            <span class="badge bg-danger ms-1" *ngIf="item?.has_negative_answers"
                                                title="Contiene respuestas negativas">
                                                <i class="fa-solid fa-triangle-exclamation"></i>
                                            </span>
                                        </td>
                                        <td class="cp-table-hide-mobile" *ngIf="!lockFacility"><span>{{item?.facility_name}}</span></td>
                                        <td><span>{{item?.guard_name}}</span></td>
                                        <td>
                                            <span class="badge"
                                                [ngClass]="item?.status=='completed' ? 'bg-primary' : 'bg-warning'">
                                                {{ item?.status=='completed' ? 'Completada' : 'En progreso' }}
                                            </span>
                                        </td>
                                        <td>
                                            <span class="badge bg-success me-1">{{item?.answers?.yes || 0}} Sí</span>
                                            <span class="badge me-1"
                                                [ngClass]="item?.answers?.no>0 ? 'bg-danger' : 'bg-secondary'">
                                                {{item?.answers?.no || 0}} No
                                            </span>
                                            <span class="badge bg-warning" *ngIf="item?.answers?.pending>0">
                                                {{item?.answers?.pending}} pend.
                                            </span>
                                        </td>
                                        <td class="cp-table-hide-mobile"><span>{{item?.started_at}}</span></td>
                                        <td class="cp-table-hide-mobile"><span>{{item?.finished_at || '-'}}</span>
                                        </td>
                                        <td>
                                            <div class="btn-group" role="group">
                                                <button type="button" class="btn text-primary"
                                                    (click)="openView(item.id, view)">
                                                    <i class="fa-solid fa-eye"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="!executions?.length">
                                    <tr>
                                        <td colspan="9" class="fw-lighter text-muted">No se encontraron ejecuciones
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="navTasks"></div>
</div>
<ng-template #noId>
    No se ha recibido el identificador de la instalación
</ng-template>

<ng-template #add let-c="close " let-d="dismiss">
    <div class="modal-header">
        <h5 class="modal-title">Nueva lista de tareas</h5>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body shadow-lg">
        <app-add-task-checklist [facilityId]="currentFacilityId" (success)="getChecklists()" />
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</ng-template>
<ng-template #edit let-c="close " let-d="dismiss">
    <div class="modal-header">
        <h5 class="modal-title">Editar lista de tareas</h5>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body shadow-lg">
        <app-edit-task-checklist [dataId]="idSelected" (success)="getChecklists()" />
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</ng-template>
<ng-template #view let-c="close " let-d="dismiss">
    <div class="modal-header">
        <h5 class="modal-title">Detalle de ejecución</h5>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body shadow-lg">
        <app-view-task-execution [dataId]="executionIdSelected" />
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cerrar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</ng-template>
